import { HTTP_CODE } from '@/utils/request'
import * as service from './service'
import Toast from 'antd-mobile/es/toast'
export default {
  namespace: 'propVoidProp',
  state: {
    demoData: {}
  },
  effects: {
    * getPropList ({ payload }, { call, put }) {
      const res = yield call(service.courierPropList, payload)
      if (res.status !== HTTP_CODE.success) {
        console.error(res.data.err)
      }
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
